const data = {
  pageName: "PaymentResult",
  paymentCanceled: false,
  transactionSubmitted: true,
  source: "VFAPP",

  paymentDetails: {
    orderAmount: 40.0,
    orderid: "O2016002",
    paymentDate: "11/12/18",
    payMethod: "Πιστωτική κάρτα",
    submitDXLFailed: false,
    bonusPoints: 1000,
    bonusAmount: 10.1,
    extInstallmentperiod: 2
  }
};

exports.data = data;
